export const Types = {
    SAVE_LIST_SERVICE: 'SAVE_LIST_SERVICE',
}
